/**
 * Autore: Salvo de Luca
 * Azienda: Dialogicom s.r.l.s.
 * File: src/config/headerExtras.tsx
 * Descrizione: Configurazione extraFixed per CustomHeader (logo Dialogicom + pulsante login operatori + user info + dev simulator)
 */

import MobileOperatorLoginButton from '../components/mobile-operators/MobileOperatorLoginButton';
import SedeSelector from '../components/SedeSelector';
import { WhatsAppStatusIndicator } from '../components/whatsapp-status-bot/components/WhatsAppStatusIndicator';

export const getHeaderExtras = (user: any) => [
  // Selettore sede (solo per utenti loggati)
  ...(user ? [{
    id: 'sede-selector',
    content: <SedeSelector />,
    align: 'right' as const
  }] : []),
  {
    id: 'dialogicom-credit',
    content: (
      <div
        className="flex flex-col items-center justify-center gap-0.5 px-4 rounded-lg cursor-pointer transition-all duration-300 hover:scale-[1.15] hover:shadow-2xl hover:shadow-green-500/30 hover:z-50 backdrop-blur-sm h-[48px] relative"
        style={{
          background: 'linear-gradient(30deg, #5CC86B 0%, #2C929F 50%, #1664B6 100%)',
          border: '1px solid rgba(255, 255, 255, 0.3)'
        }}
      >
        <span className="text-[8px] text-white/80 font-light tracking-wide">developed by</span>
        <img
          src="/assets/Dialogicom_432x144-ByfqQ1hp.webp"
          alt="Dialogicom"
          className="h-6 object-contain opacity-95 hover:opacity-100 transition-opacity"
        />
      </div>
    ),
    align: 'right' as const
  },
  {
    id: 'mobile-operator-login',
    content: <MobileOperatorLoginButton />,
    align: 'right' as const
  },
  // User info - nome utente e ruolo (prima di whatsapp per garantire visibilità)
  {
    id: 'user-info',
    content: (
      <div
        className="flex flex-col items-center justify-center gap-1 px-4 rounded-lg cursor-help transition-all duration-300 hover:scale-[1.15] hover:shadow-2xl hover:shadow-cyan-500/30 hover:z-50 backdrop-blur-sm h-[48px] relative"
        style={{
          background: 'linear-gradient(135deg, #2563eb 0%, #0891b2 50%, #0e7490 100%)',
          border: '1px solid rgba(255, 255, 255, 0.3)'
        }}
        title={user?.email || ''}
      >
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 bg-cyan-200 rounded-full animate-pulse" />
          <span className="text-white text-sm font-semibold drop-shadow-md">
            {user?.name || 'Utente'}
          </span>
        </div>
        <div className="text-[11px] text-cyan-50 font-medium">
          {user?.role === 'superadmin' ? '👑 Super Admin' :
           user?.role === 'admin' ? '⚡ Admin' :
           (user as any)?.group_name || user?.role || 'Utente'}
        </div>
      </div>
    ),
    align: 'right' as const
  },
  // WhatsApp Bot Status Indicator (solo per superadmin)
  ...(user?.role === 'superadmin' ? [{
    id: 'whatsapp-status',
    content: <WhatsAppStatusIndicator />,
    align: 'right' as const
  }] : []),
];
